export default "__VITE_ASSET__19114315__"